import styled from "styled-components";

import { ReactComponent as Email } from "../../../assets/img/auth_onboarding/email.svg";
import { Icon } from "../../../components/Icon";
import { AuthCard, AuthContainer, AuthNavLink } from "../shared/authStyles";

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

const EmailIconContainer = styled.div`
  height: 80px;
  width: 93px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 400px;
  align-items: flex-start;
`;

const TitleText = styled.p`
  font-family: "Mona Sans", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353a46;
  margin: 0;
  width: 100%;
`;

const EmailText = styled.p`
  font-family: "Mona Sans", sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  color: #000e2a;
  margin: 0;
  word-break: break-all;
`;

const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  align-items: flex-start;
`;

const DescriptionText = styled.p`
  font-family: "Mona Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #353a46;
  margin: 0;
  width: 100%;
`;

const ForgotPasswordSuccess = ({ email }) => {
  return (
    <AuthContainer>
      <AuthCard
        initial={{ opacity: 0, y: 20, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
      >
        <SuccessContainer>
          <EmailIconContainer>
            <Icon component={Email} size="80px" />
          </EmailIconContainer>

          <TitleSection>
            <TitleText>Password reset link been sent to</TitleText>
            <EmailText>{email}</EmailText>
          </TitleSection>

          <DescriptionSection>
            <DescriptionText>
              Check your inbox including spam folder to get reset link. Click on
              that link and reset password.
            </DescriptionText>
            <AuthNavLink to="/auth/login" color="#2266ef">
              Back to Sign in page
            </AuthNavLink>
          </DescriptionSection>
        </SuccessContainer>
      </AuthCard>
    </AuthContainer>
  );
};

export default ForgotPasswordSuccess;
